import { render } from "./Periods.vue?vue&type=template&id=948981a4&scoped=true"
import script from "./Periods.vue?vue&type=script&lang=js"
export * from "./Periods.vue?vue&type=script&lang=js"

import "./Periods.vue?vue&type=style&index=0&id=948981a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-948981a4"]])

export default __exports__